import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Flex } from '@coolblue-development/freddy';
import InsuranceChipGroup from './InsuranceChipGroup.js';
import InsuranceSelectableGroup from './InsuranceSelectableGroup.js';
import InsuranceSelectableGroupMobile from './InsuranceSelectableGroupMobile/index.js';
import { PresentationTracking } from './PresentationTracking.js';
export function InsuranceSelector({ productType }) {
    return (_jsxs(PresentationTracking, { children: [_jsxs(Flex, { direction: "column", hideUntil: "md", gap: 400, children: [_jsx(InsuranceChipGroup, {}), _jsx(InsuranceSelectableGroup, { productType: productType })] }), _jsx(Box, { hideFrom: "md", children: _jsx(InsuranceSelectableGroupMobile, { productType: productType }) })] }));
}
//# sourceMappingURL=InsuranceSelector.js.map